import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Http, Headers } from '@angular/http';
import { ApiService } from '../../../../core/services/api.service';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  modalType: any;
  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    private http: Http,
    private api: ApiService,
    private afs: AngularFirestore,

    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.modalType = data.modalType;
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.afs.collection('userSuggestions').doc(this.data.key).delete();
    this.dialogRef.close();
  }

  changeText(string) {
    return string
      .trim()
      .replace(/ö/g, 'o')
      .replace(/Ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/Ç/g, 'c')
      .replace(/ş/g, 's')
      .replace(/Ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/İ/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/Ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/Ü/g, 'u')
      .replace('&', 've')
      .replace(/,/g, '')
      .replace(/\./g, '_')
      .replace(/\-/g, '')
      .replace(/\'/g, '')
      .replace(/\s/g, '')
      .toLowerCase();
  }


  sendEmail() {
    this.dialogRef.close();
    const { category, type, url, user, isSeen, name } = this.data.product;
    let parameters = {
      email: user.email,
      firstname: user.firstname,
      lastname: user.lastname,
      urlPath: this.changeText(name),
      name: name
    };

    this.dialogRef.close();
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return this.http.post(`https://testapi.bigadvice.com/email/sendThanksForSuggestion`, parameters, { headers: headers }).subscribe();
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/suggestions/dialog/dialog.component.ts